import moment from "moment";
import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { ADD_NEW_TASK, SHOW_NOTIFICATION } from "../constants";
import { createCrudActions } from "../utils/crudGenerator";

const formatTasks = (data) => {
	if (!data) {
		return [];
	}
	const formatItem = (item) => ({
		...item,
		label: `${item.description}`,
		value: item._id,
		endDate: item.endDate && moment(item.endDate),
		startDate: item.startDate && moment(item.startDate),
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}
	return formatItem(data);
};

export const { fetch: fetchTasks, create: createTask, update: updateTask, delete: deleteTasks } = createCrudActions("TASK", "Tarea", formatTasks);
const pendingProjectSummaryRequests = new Map();

export const createTaskAndReturn = (newTask) => {
	return async (dispatch) => {
		try {
			dispatch({ type: "TASK_FORM_TOGGLE_LOADING" });
			const response = await axios.post("TASK", newTask);
			const formattedTask = formatTasks(response.data);
			dispatch({ type: ADD_NEW_TASK, payload: formattedTask });
			dispatch({ type: "TASK_FORM_TOGGLE_LOADING" });
			dispatch({
				type: SHOW_NOTIFICATION,
				payload: {
					show: true,
					status: "success",
					message: "Tarea creada con éxito.",
				},
			});
			return { status: response.status, task: formattedTask };
		} catch (err) {
			dispatch({ type: "TASK_FORM_TOGGLE_LOADING" });
			return { status: err?.response?.status || 500, error: err };
		}
	};
};

// Resumen de tareas por fase para un proyecto concreto
export const fetchProjectTasksSummary = (projectId) => {
	return async () => {
		if (!projectId) return null;
		if (pendingProjectSummaryRequests.has(projectId)) {
			return pendingProjectSummaryRequests.get(projectId);
		}

		const requestPromise = axios
			.get(API.projects.tasksSummary(projectId))
			.then((response) => response.data)
			.catch((err) => err)
			.finally(() => {
				pendingProjectSummaryRequests.delete(projectId);
			});

		pendingProjectSummaryRequests.set(projectId, requestPromise);
		return requestPromise;
	};
};
